"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationsReport = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const certifications_report_header_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/certifications-report/components/certifications-report-header");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const number_formatter_1 = require("../claim-analytics/number-formatter");
require("./certifications-report.less");
let CertificationsReport = class CertificationsReport extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Assets_Report.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            // anything specified in defaultColDef gets applied on all columns
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    else {
                        return a > b ? 1 : a < b ? -1 : 0;
                    }
                }
            },
            columnDefs: [
                {
                    headerName: "Pharmacy Name",
                    field: "Pharmacy Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Entity Name",
                    field: "Entity Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Entity Type",
                    field: "Entity Type",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Description",
                    field: "Description",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Original File Name",
                    field: "Original File Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Requirement",
                    field: "Category",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Required",
                    field: "Required",
                    enableRowGroup: true
                },
                {
                    headerName: "Completion Status",
                    field: "Completion Status",
                    enableRowGroup: true
                },
                {
                    headerName: "Expiration Status",
                    field: "Expiration Status",
                    enableRowGroup: true
                },
                {
                    headerName: "Expiration Date",
                    field: "Expiration Date",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Upload Date",
                    field: "Upload Date",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                }
            ],
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            }
        };
    }
    async componentDidMount() {
        await store_1.reportsStore.loadCertificationsReport();
    }
    componentWillUnmount() {
        store_1.reportsStore.certificationsReportData = null;
        store_1.reportsStore.certOptionMissing = false;
    }
    render() {
        const storeData = store_1.reportsStore.certificationsReportData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        let columnDefs = this.storeData.columnDefs;
        if (store_1.reportsStore.certOptionMissing) {
            columnDefs = this.storeData.columnDefs.filter((col) => col.field === "Pharmacy Name" ||
                col.field === "Entity Name" ||
                col.field === "Entity Type" ||
                col.field === "Category" ||
                col.field === "Required");
        }
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(certifications_report_header_1.CertificationsReportHeader, { title: "Assets Report" }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: columnDefs, defaultColDef: this.storeData.defaultColDef, 
                        /* this is where we provide custom components */
                        frameworkComponents: this.storeData.frameworkComponents, 
                        /* this is where we enable multiple column sorting with 'ctrl' key/ 'Cmd' key on apple (default was the 'shift' key) */
                        multiSortKey: this.storeData.multiSortKey, 
                        /* this is where we provide animation while sorting */
                        animateRows: true, 
                        /* this is where we enable the sidebar with pivoting and filtering */
                        sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, 
                        /* disable Excel export until we are able to handle export in the back end - only CSV export available for now */
                        suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(certifications_report_header_1.CertificationsReportHeader, { title: "Assets Report" }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(certifications_report_header_1.CertificationsReportHeader, { title: "Assets Report" }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
CertificationsReport = __decorate([
    mobx_react_1.observer
], CertificationsReport);
exports.CertificationsReport = CertificationsReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/certifications-report/certifications-report.tsx
// module id = 3931
// module chunks = 0